import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['star', 'ratingInput'];

  updateStars(event) {
    let selectedStarIndex = this.starTargets.indexOf(event.currentTarget);
    this.ratingInputTargets[selectedStarIndex].checked = true;

    // Update the stars' appearance
    this.starTargets.forEach((star, index) => {
      let svgElement = star.querySelector('svg');
      index <= selectedStarIndex ? svgElement.classList.add('active-star') : svgElement.classList.remove('active-star');
    });
  }
}
